<template>
  <!-- Main content -->
  <section class="content clearfix">
    <div class="info-widgets clearfix">
      <info-widget
        :stats="{ title: 'Countries', stat: countries }"
        backgroundColor="#00beee"
        color="#fff"
        animate
        logo="fa fa-globe"
        class="col-xs-12 col-sm-6 col-md-3">
      </info-widget>
      <info-widget
        :stats="{ title: 'Locations', stat: locations }"
        backgroundColor="#02a85c"
        logo="fa fa-map-marker"
        color="#fff"
        animate
        class="col-xs-12 col-sm-6 col-md-3">
      </info-widget>
      <info-widget
        :stats="{ title: 'Jobs', stat: jobs }"
        backgroundColor="#f39c11"
        logo="fa fa-industry"
        color="#fff"
        animate
        class="col-xs-12 col-sm-6 col-md-3">
      </info-widget>
      <info-widget
        :stats="{ title: 'Users', stat: users }"
        backgroundColor="#f56854"
        logo="fa fa-user"
        color="#fff"
        animate
        class="col-xs-12 col-sm-6 col-md-3">
      </info-widget>
    </div>
    <div class="row row-eq-height p-15">
      <div class="col-xs-12 col-md-6">
        <div id="big-chart" class="clearfix">
          <div class="panel panel-default mai-panel">
            <div class="panel-heading"><i class="fa fa-bar-chart"></i> Most recent 100 jobs <small>- by destination country</small></div>
            <div class="panel-body clearfix" style="min-height: 380px;">
              <am-map :mapData="mapData"></am-map>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="panel panel-default mai-panel">
          <div class="panel-heading"><i class="fa fa-bar-chart"></i> Most recent 100 jobs <small>- by origin country</small></div>
          <div class="panel-body" style="min-height: 380px;">
            <simple-bar :chartData="chartData" categoryField="Country" valueField="count"></simple-bar>
          </div>
        </div>
      </div>
    </div>
    <div class="info-widgets clearfix">
      <info-widget
        :stats="{ title: 'Currencies', stat: currencies }"
        backgroundColor="#f56854"
        logo="fa fa-usd"
        color="#fff"
        animate
        class="col-xs-12 col-sm-6 col-md-3">
      </info-widget>
      <info-widget
        :stats="{ title: 'Parties', stat: parties }"
        backgroundColor="#f39c11"
        logo="fa fa-address-book"
        color="#fff"
        animate
        class="col-xs-12 col-sm-6 col-md-3">
      </info-widget>
      <info-widget
        v-if="hasPermission($store, 'QUOTE')"
        style="cursor:pointer;"
        :stats="{ title: 'Quotes - Add New', stat: 'Go Now' }"
        backgroundColor="#02a85c"
        logo="fa fa-plus-square"
        color="#fff"
        class="col-xs-12 col-sm-6 col-md-3"
        v-on:clicked="$router.push({ name: 'Add a new Quote' })">
      </info-widget>
      <info-widget
        v-if="hasPermission($store, 'QUOTE')"
        style="cursor:pointer;"
        :stats="{ title: 'Quotes - Batch Upload', stat: 'Go Now' }"
        backgroundColor="#00beee"
        color="#fff"
        logo="fa fa-upload"
        class="col-xs-12 col-sm-6 col-md-3"
        v-on:clicked="$router.push({ name: 'Quote Batch Upload' })">
        >
      </info-widget>
    </div>
    <div class="col-xs-12">
      <vue-table class="mai-panel" :tableData="recentJobs" :fields="fields" tableTitle="Most recent 100 jobs" style="padding: 0 !important;"></vue-table>
    </div>
  </section>
  <!-- /.content -->
</template>
<script>
import Bar from '../charts/SimpleBar.vue'
import VueTable from '../../modules/helpers/VueTable.vue'
import InfoWidget from '../../modules/helpers/InfoWidget'
import AmMap from '../charts/AmMap'
import SimpleBar from '../charts/SimpleBar'
import Permissions from '../../mixins/Permissions'
export default {
  mixins: [Permissions],
  data () {
    return {
      fields: [
        {
          header: 'ID',
          prop: 'id',
          numericalField: true
        },
        {
          header: 'Origin Location',
          prop: item => item.fromLocation ? this.displayLocation(item.fromLocation) : ''
        },
        {
          header: 'Destination Location',
          prop: item => item.toLocation ? this.displayLocation(item.toLocation) : ''
        }
      ]
    }
  },
  components: {
    Bar,
    VueTable,
    InfoWidget,
    AmMap,
    SimpleBar
  },
  methods: {
    displayLocation (location) {
      let str = ''
      if (location.name) {
        str += location.name
      }
      if (location.subdivision) {
        str += `, ${location.subdivision}`
      }
      if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
        str += `, ${location.country.code}`
      }
      return str
    }
  },
  computed: {
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    },
    currencies () {
      return this.$store.getters['systemOption/currencies'].length
    },
    countries () {
      return this.$store.getters['systemOption/countries'].length
    },
    counts () {
      return this.$store.getters['stats/count']
    },
    recents () {
      return this.$store.getters['stats/recent']
    },
    jobs () {
      return this.counts.hasOwnProperty('job') ? this.counts.job.value : ''
    },
    users () {
      return this.counts.hasOwnProperty('mai-user') ? this.counts['mai-user'].value : ''
    },
    parties () {
      return this.counts.hasOwnProperty('party') ? this.counts.party.value : ''
    },
    locations () {
      return this.counts.hasOwnProperty('location') ? this.counts.location.value : ''
    },
    recentJobs () {
      return this.recents.hasOwnProperty('job') ? this.recents.job : []
    },
    mapData () {
      let data = []
      this.recentJobs.forEach(({toLocation}) => {
        if (toLocation !== null && toLocation.country !== null) {
          const { code, name } = toLocation.country
          let addNew = true
          data.forEach(country => {
            if (country.code === code) {
              addNew = false
              country.value++
            }
          })
          if (addNew) {
            data.push({ code, name, value: 1 })
          }
        }
      })
      return data
    },
    chartData () {
      let data = []
      this.recentJobs.forEach(({fromLocation}) => {
        if (fromLocation !== null && fromLocation.country !== null) {
          const { name } = fromLocation.country
          let addNew = true
          data.forEach(country => {
            if (country.Country === name) {
              addNew = false
              country.count++
            }
          })
          if (addNew) {
            data.push({ Country: name, count: 1 })
          }
        }
      })
      return data
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
#info-boxes {
  margin: 10px 5px;
}
#right-pie {
  height: 650px;
}
.go-search {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 80px;
}
.go-search .fa {
  animation: flasher 2s infinite;
  color: #000;
}
@keyframes flasher {
  0% {
    opacity: 1
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.info-widgets {
  margin: 20px 0;
}
.p-15 {
  padding: 15px;
}
.mai-user-panel {
  background-color: #eee;
}
.mai-user-panel .panel-body {
  margin: 10px;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  transition: box-shadow 0.5s;
}
.mai-user-panel .panel-body:hover {
  -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
}
</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue